<template>
	<svg class="ls-icon ls-icon-dropoff" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
		<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
			<circle cx="12" cy="12" r="10" />
			<path d="M12 8v8m-4-4l4 4l4-4" />
		</g>
	</svg>
</template>
